
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 100 125"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M86.949 65.155l-18-6a2.993 2.993 0 00-3.271.946l-4.463 5.455A48.468 48.468 0 0134.44 38.785l5.458-4.462a3.002 3.002 0 00.948-3.272l-6-18A2.999 2.999 0 0032 11h-6.939C17.309 11 11.001 17.306 11 25.057c-.006 17.079 6.642 33.135 18.715 45.214C41.79 82.35 57.844 89 74.923 89 82.685 89 89 82.684 89 74.923V68a2.996 2.996 0 00-2.051-2.845zM83 74.923C83 79.376 79.376 83 74.923 83 59.447 83 44.9 76.974 33.959 66.028S16.996 40.534 17 25.058C17.001 20.615 20.617 17 25.061 17h4.777L34.5 30.986l-5.531 4.523a2.996 2.996 0 00-.927 3.33c5.536 15.511 17.607 27.582 33.119 33.116a2.995 2.995 0 003.33-.926l4.523-5.528L83 70.162v4.761z"}})])
          )
        }
      }
    